module.exports = __webpack_public_path__ + "img/材料力学7_3_3.92fab763.jpg";